import { render, staticRenderFns } from "./sample-apply.vue?vue&type=template&id=c774e638&scoped=true"
import script from "./sample-apply.vue?vue&type=script&lang=ts"
export * from "./sample-apply.vue?vue&type=script&lang=ts"
import style0 from "./sample-apply.vue?vue&type=style&index=0&id=c774e638&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c774e638",
  null
  
)

export default component.exports